var map = {
	"./__Amsterdam_0.jpeg": 460,
	"./__Amsterdam_1.jpeg": 538,
	"./__Amsterdam_10.jpeg": 186,
	"./__Amsterdam_3.jpeg": 451,
	"./__Bangladesh_0.jpeg": 618,
	"./__Bangladesh_1.jpeg": 666,
	"./__Bangladesh_10.jpeg": 54,
	"./__Bangladesh_3.jpeg": 812,
	"./__Lissabon_0.jpeg": 722,
	"./__Lissabon_1.jpeg": 15,
	"./__Lissabon_10.jpeg": 244,
	"./__Lissabon_3.jpeg": 206,
	"./__London_0.jpeg": 387,
	"./__London_1.jpeg": 693,
	"./__London_10.jpeg": 621,
	"./__London_3.jpeg": 721,
	"./__NewYork_0.jpeg": 84,
	"./__NewYork_1.jpeg": 456,
	"./__NewYork_10.jpeg": 329,
	"./__NewYork_3.jpeg": 283,
	"./__Venedig_0.jpeg": 21,
	"./__Venedig_1.jpeg": 162,
	"./__Venedig_10.jpeg": 160,
	"./__Venedig_3.jpeg": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;